import React from 'react';

import { CapsulesTableSkeleton } from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesTable';
import styles from 'new/modules/settings/capsules/screens/CapsulesSettingsScreen/components/CapsulesTable/CapsulesTableRegion/CapsulesTableRegion.module.scss';

export const CapsulesInitialLoading: React.FC = () => {
  return (
    <div className={styles.tableRegion}>
      <CapsulesTableSkeleton />
    </div>
  );
};
